import React, {useEffect,useState} from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import queryString from "query-string";
import moment from 'moment';

import ListView from "../Diaries/ListView/";
import ToDoCalendar from "./CalenderView/todoCalendar";
import { toggleDiaryView, resetViewDiaryInfo} from "../Diaries/actions";
import { showDialogueBox, hideDialogueBox } from "../../components/DialogueBox/actions";
import ErrorScreen from "../../ErrorScreens";
import DiaryDetailPopUp from '../../components/DiaryDetailPopUp';

const DiariesListing = (props) => {
    const { view, canUserView, appError } = useSelector(state => ({
        view: state.diaries.view.view,
        canUserView: state.sessionContextOidc.userView,
        appError: state.appError,
    }), shallowEqual);

    const dispatch = useDispatch();
    const [selectedDate,setSelectedDate]=useState('');

    useEffect(()=>{
        document.querySelector('body').classList.add('bodyScroll');        
        const QuerySearchValues = queryString.parse(props?.location?.search);
        if(QuerySearchValues.tvw)
            dispatch(toggleDiaryView({view:QuerySearchValues.tvw}));
        else 
            dispatch(toggleDiaryView({view:"list"}))
        if(QuerySearchValues.dueDate && QuerySearchValues.id){
            setSelectedDate(QuerySearchValues.dueDate);
            openDiaryDetail(QuerySearchValues);
        }
    },[]);

    const openDiaryDetail = (value)=>{
        dispatch(
            fetchDiaryInfo({
              target: null,
              id: value.id,
              key: moment(value.dueDate).format('D,hh A'),
              isErrorScreen:true
            })
          );
        dispatch(
        showDialogueBox({
            flag: true,
            component: (
            <DiaryDetailPopUp
                dataKey={moment(value.dueDate).format('D,hh A')}
                onClose={() => {
                    dispatch(hideDialogueBox());
                    dispatch(resetViewDiaryInfo());
                }}
            />
            ),
            overlayClassName: "modal",
            contentClassName: "modalContent animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: false,
        })
        );
    }

    useEffect(()=>{
        if(appError.status){
            if(appError.status==105)
            {
                window.location.reload();
            }
            else if(appError.isErrorScreen)
            {
              dispatch(hideDialogueBox());
              dispatch(showDialogueBox({
                flag: true,
                component: <ErrorScreen status={appError.status} history={props.history}/>,
                overlayClassName: "modal animated faster fadeIn",
                contentClassName: "modalContent globalSearchModalContent modalFixed animated faster fadeInUpx2 medium",
                shouldCloseOnOverlayClick: true
              }))
            }
         }
    },[appError]);

    const renderView=()=>{
        switch(view){
            case 'list':
                return <ListView/>;
            case 'day':
            case 'month':
                return <ToDoCalendar view={view} selectedDate={selectedDate}/>;
            default:
                break;
        }
    }

    return (
        <div className="detailPage">
            {
               canUserView && renderView()
            }
        </div>
    )
}

export default DiariesListing;